import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-input',
  standalone: true,
  imports: [FormsModule],
  template: `
    <label class="input-shell">
      @if (label()) {
        <span>{{ label() }}</span>
      }
      <input
        [type]="type()"
        [required]="required()"
        [placeholder]="placeholder()"
        [readOnly]="readOnly()"
        [attr.maxlength]="maxLength() ?? undefined"
        [ngModel]="value()"
        (ngModelChange)="valueChange.emit($event)"
        (focus)="focused.emit()"
        (blur)="blurred.emit()"
      />
    </label>
  `,
  styles: [
    `
      .input-shell {
        display: grid;
        gap: 4px;
      }

      .input-shell span {
        font-size: 12px;
        color: var(--faint);
      }

      .input-shell input {
        height: 36px;
        border: 1px solid var(--border);
        border-radius: 10px;
        background: var(--bg-surface);
        color: var(--text);
        padding: 0 10px;
        font-size: 13px;
      }
    `,
  ],
})
export class InputComponent {
  readonly label = input<string>('');
  readonly value = input<string | number | null>(null);
  readonly valueChange = output<string | number | null>();
  readonly focused = output<void>();
  readonly blurred = output<void>();
  readonly type = input<'text' | 'number' | 'email' | 'tel'>('text');
  readonly placeholder = input<string>('');
  readonly required = input<boolean>(false);
  readonly readOnly = input<boolean>(false);
  /** Quando definido, limita o tamanho (ex.: telefone mascarado BR). */
  readonly maxLength = input<number | null>(null);
}
